import { z } from 'zod';
import { MEMBERSHIP_PRODUCT_TYPE, SORT_TYPE } from '../type';

const projectId = z.string();
const orderAtSortType = z.nativeEnum(SORT_TYPE);

export const MembershipCreatorOrdersReqBodySchema = z.object({
  projectId,
  membershipId: z.string().optional(),
  goodsTypeId: z.nativeEnum(MEMBERSHIP_PRODUCT_TYPE).optional(),
  page: z.number().int().min(1),
  size: z.number().int().min(1).max(100).optional(),
  orderAtSortType,
});

export const MembershipUserOrdersReqBodySchema = z.object({
  projectId,
  uid: z.string(),
  orderAtSortType,
});
